import React from 'react';
import { Button, Divider, Form, Input } from 'antd';
import { GoogleLogin } from 'react-google-login';
import { handleGAEvent } from '../../helperFunctions';
import { GACategories, GAActions } from '../../analytics';
import styles from './InviteContainer.scss';

const EmailForm = ({ email_id, onRequestOTP, onGoogleResponse }) => (
  <div className={styles['c-invite__email']}>
    <Form
      onFinish={onRequestOTP}
      variant="filled"
      initialValues={{ email: email_id }}
      validateMessages={{
        required: '${label} is required!',
        types: { email: '${label} is not valid!' },
      }}
    >
      <Form.Item
        name="email"
        rules={[{ required: true, type: 'email' }]}
      >
        <Input
          style={{ borderRadius: 2 }}
          placeholder="xyz@gmail.com"
        />
      </Form.Item>
      <Button
        type="primary"
        htmlType="submit"
        style={{ width: '100%', height: '40px', borderRadius: 2 }}
      >
        Request OTP
      </Button>
    </Form>
    <Divider
      plain
      style={{ borderColor: '#D9D9D9' }}
    >
      or log in with
    </Divider>
    <GoogleLogin
      clientId="73660977592-m50kcgualicen86vokvsbg3vsh8h6c2e.apps.googleusercontent.com"
      buttonText="Sign in with Google"
      responseType="code"
      onSuccess={handleGAEvent(onGoogleResponse, GACategories.auth, GAActions.googleLogin)}
      onFailure={onGoogleResponse}
    />
  </div>
);
export default EmailForm;
